import IconsTextNavigation from 'components/global/IconsTextNavigation'
import DonationModal from 'pages/Events/Views/Common/Modals/DonationModal'
import React, { useState } from 'react'
import { classesEventStore } from 'state/classes/classesStore'

const Donation: React.FC = () => {
  const { classesData } = classesEventStore(store => ({
    classesData: store.classesData,
  }))
  const [donationModal, setDonationModal] = useState<boolean>(false)

  return (
    <>
      <div onClick={() => setDonationModal(true)}>
        <IconsTextNavigation
          iconName="HandHeart"
          heading="Donations"
          isCompleted={classesData?.allowDonation}
        />
      </div>

      {donationModal && (
        <DonationModal
          openModal={donationModal}
          setOpenModal={setDonationModal}
          reference="class"
        />
      )}
    </>
  )
}

export default Donation
